"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFields = exports.getFieldConfig = void 0;
var compose_1 = __importDefault(require("lodash/fp/compose"));
var prop_1 = __importDefault(require("lodash/fp/prop"));
var values_1 = __importDefault(require("lodash/fp/values"));
var filter_1 = __importDefault(require("lodash/fp/filter"));
var map_1 = __importDefault(require("lodash/fp/map"));
var uniq_1 = __importDefault(require("lodash/fp/uniq"));
var fromPairs_1 = __importDefault(require("lodash/fp/fromPairs"));
var getAddressFields = function (country) { return (0, compose_1.default)(values_1.default, (0, prop_1.default)("".concat(country, ".addressForm.addressFields"))); };
var getFieldConfig = function (config) { return function (country) { return function (field) { return function (position) {
    return (0, compose_1.default)((0, prop_1.default)(position), fromPairs_1.default, (0, map_1.default)(function (fieldConfig) { return ([(0, prop_1.default)('position')(fieldConfig), fieldConfig]); }), (0, filter_1.default)({ addressPart: field }), getAddressFields(country))(config);
}; }; }; };
exports.getFieldConfig = getFieldConfig;
var getFields = function (config) { return function (country) {
    return (0, compose_1.default)(uniq_1.default, (0, map_1.default)((0, prop_1.default)('addressPart')), getAddressFields(country))(config);
}; };
exports.getFields = getFields;
